import React from 'react'
import { connect } from 'react-redux'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import LKModal, { LKModalContainer } from 'shared/LKModal'
import ClientSearch, { getTitle } from 'shared/ClientSearch'
import _ from 'lodash'

export const CLIENT_SEARCH_MODAL = 'ClientSearchModal'
export const CLIENT_SEARCH_NAME = 'ClientSearch'

const clientSearchGridConfig = {
  syncGridState: true,
  enableRowSelection: true,
  enableColumnsHide: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableSorting: true,
}

const translate = (key) => mainTranslate('frm_client_list', key)

const searchPanelConfig = (clientTypes) => {
  return {
    initialValues: {
      categ: {
        individuals: clientTypes === '1' || clientTypes.includes(1),
        solidarityGroups: clientTypes.includes(2),
        companies: clientTypes === '3' || clientTypes.includes(3),
      },
      safety: {
        blacklisted: clientTypes.includes(2) && 2,
      },
    },

    fieldsDisability: {
      categ: {
        individuals: true,
        solidarityGroups: true,
        companies: true,
      },
      safety: {
        blacklisted: clientTypes === '2' || clientTypes.includes(2),
      },
    },

    hintAboveMessage: translate('lbl_healthy_only'),
  }
}

@LKModalContainer(CLIENT_SEARCH_MODAL)
@connect((state) => ({ title: getTitle(state, { instanceName: CLIENT_SEARCH_NAME }) }))
class ClientSearchModal extends React.Component {
  onClientChoose = (row) => {
    const { closeModal } = this.props

    if (this.props.onSelectClient) {
      this.props.onSelectClient(row, false, 'Search', this.props.params)
    }

    closeModal()
  }

  onRowDoubleClicked = ({ node: { data } }) => this.onClientChoose(data)

  getContextMenuItems = ({
    node: {
      data,
      data: { Full_Name },
    },
  }) => [
    {
      name: Full_Name,
      disabled: true,
    },
    {
      name: translate('cmd_select'),
      action: () => this.onClientChoose(data),
      icon: 'hand',
    },
  ]

  render() {
    const { modalInstanceName, title, clientTypes } = this.props
    if (this.props.params.which) {
      if (!clientTypes.includes(2)) clientTypes.push(2)
    } else {
      if (clientTypes.includes(2)) {
        _.remove(clientTypes, (number) => {
          return number === 2
        })
      }
    }

    return (
      <LKModal
        name={modalInstanceName}
        heading={title}
        size="lg"
        footer={<LKModal.Footer sideActions={<LKModal.CancelButton text={translate('cmd_close')} />} />}
      >
        <ClientSearch
          instanceName={CLIENT_SEARCH_NAME}
          gridConfig={{
            ...clientSearchGridConfig,
            onRowDoubleClicked: this.onRowDoubleClicked,
            getContextMenuItems: this.getContextMenuItems,
          }}
          searchPanelConfig={searchPanelConfig(clientTypes)}
        />
      </LKModal>
    )
  }
}

export default ClientSearchModal
